import { render, staticRenderFns } from "./DiscountTag.vue?vue&type=template&id=41495782&scoped=true&"
import script from "./DiscountTag.vue?vue&type=script&lang=js&"
export * from "./DiscountTag.vue?vue&type=script&lang=js&"
import style0 from "./DiscountTag.vue?vue&type=style&index=0&id=41495782&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41495782",
  null
  
)

export default component.exports